function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { isSlideAvailable, getSlideIndex, getNearestAvailable } from "../utils/helpers";
import Tracker from "../utils/piwik";
import sum from "lodash/sum";
import { NAV_GOTO_SLIDE, NAV_NEXT_SLIDE, NAV_PREV_SLIDE, setCurrentSlide, logError, completeSlide, sendNotification, fetchExamInteractions, initExam, resetExam, finishExam, setExamPosition, setLastVisitedSlide } from "../actions";
var timestamp = +new Date();
export default function onNav(action$, state$) {
    return action$.pipe(ofType(NAV_GOTO_SLIDE, NAV_NEXT_SLIDE, NAV_PREV_SLIDE), switchMap(function(action) {
        var slides = state$.value.nodes.filter(function(n) {
            return n.target_type !== "Filter";
        });
        var currentIndex = getSlideIndex(state$.value.currentSlide, state$.value);
        var targetNode;
        // ******************************************************************************************** //
        // **************************** HANDLE NAVIGATION DURING CBOOK EXAMS **************************** //
        if (!!state$.value.exam && state$.value.exam.state === "running") {
            // SCORM tracking of Tests
            var _position = state$.value.exam.position;
            var _actions = [
                setLastVisitedSlide({
                    id: state$.value.currentSlide
                })
            ];
            var interactions = state$.value.examInteractions[state$.value.exam.id];
            if (interactions) {
                var node = interactions[_position];
                if (node && isSlideAvailable(node, state$.value) && action.type === NAV_NEXT_SLIDE) {
                    // if user is on last question in exam
                    if (_position === interactions.length - 1) {
                        var _state$_value_cbook;
                        var success;
                        var correctAnswers = state$.value.exam.answers && state$.value.exam.answers.length ? state$.value.exam.answers.filter(function(a) {
                            return !!a.status;
                        }) : [];
                        if ((_state$_value_cbook = state$.value.cbook) === null || _state$_value_cbook === void 0 ? void 0 : _state$_value_cbook.use_credit_points) {
                            var _state$_value_nodes_find, _state$_value_nodes;
                            var totalPoints = sum(interactions.filter(function(a) {
                                return correctAnswers.map(function(c) {
                                    return c.id;
                                }).includes(a.id);
                            }).map(function(a) {
                                return a.credit_points;
                            }));
                            var passingRequirements = (_state$_value_nodes_find = (_state$_value_nodes = state$.value.nodes) === null || _state$_value_nodes === void 0 ? void 0 : _state$_value_nodes.find(function(n) {
                                var _state$_value_exam;
                                return n.id === ((_state$_value_exam = state$.value.exam) === null || _state$_value_exam === void 0 ? void 0 : _state$_value_exam.id);
                            })) === null || _state$_value_nodes_find === void 0 ? void 0 : _state$_value_nodes_find.passing_requirements;
                            success = totalPoints >= (passingRequirements || 0);
                        } else {
                            var _state$_value_nodes_find1, _state$_value_nodes1;
                            var percentage = correctAnswers.length / interactions.length * 100;
                            var minScore = (_state$_value_nodes_find1 = (_state$_value_nodes1 = state$.value.nodes) === null || _state$_value_nodes1 === void 0 ? void 0 : _state$_value_nodes1.find(function(n) {
                                var _state$_value_exam;
                                return n.id === ((_state$_value_exam = state$.value.exam) === null || _state$_value_exam === void 0 ? void 0 : _state$_value_exam.id);
                            })) === null || _state$_value_nodes_find1 === void 0 ? void 0 : _state$_value_nodes_find1.min_score;
                            success = percentage >= (minScore || 0);
                        }
                        _actions.push(completeSlide({
                            id: state$.value.exam.id,
                            status: success ? "passed" : "failed"
                        }));
                        _actions.push(finishExam());
                    } else {
                        var position = _position + 1;
                        if (interactions[position]) {
                            _actions.push(setExamPosition({
                                position: position
                            }));
                        }
                    // } else if (!interactions[position] && _position === interactions.length - 1) {
                    //   // it is the last slide, and the user tries to navigate to result page without answering all questions because navigation is generally allowed in this exam
                    //   _actions.push(sendNotification({ key: `question-not-answered-${node.id}`, label: 'ui.no_permissions', message: 'navigation.question_not_answered', messageProps: { } }))
                    // }
                    }
                } else if (// ******** BACKWARDS NAVIGATION IN EXAM ******** //
                node && isSlideAvailable(node, state$.value) && action.type === NAV_PREV_SLIDE) {
                    // if it is not the first slide in the exam
                    if (_position > 0) {
                        var position1 = _position - 1;
                        if (interactions[position1]) {
                            _actions.push(setExamPosition({
                                position: position1
                            }));
                        }
                    } else {
                        _actions.push(sendNotification({
                            key: "action_not_allowed_while_exam",
                            message: "action_not_allowed_while_exam",
                            label: ""
                        }));
                    }
                } else {
                    // ******** FORWARD NAVIGATION IN EXAM ******** //
                    _actions = action.type === NAV_NEXT_SLIDE ? [
                        sendNotification({
                            key: "question-not-answered-".concat(node === null || node === void 0 ? void 0 : node.id),
                            label: "ui.no_permissions",
                            message: "navigation.question_not_answered",
                            messageProps: {}
                        })
                    ] : [
                        sendNotification({
                            key: "action_not_allowed_while_exam",
                            message: "action_not_allowed_while_exam",
                            label: ""
                        })
                    ];
                }
            }
            return _actions;
        }
        // ******************************************************************************************** //
        // **************************** HANDLE GENERAL NAVIGATION IN CBOOK **************************** //
        switch(action.type){
            // set navigation target node according to redux action type
            case NAV_NEXT_SLIDE:
                targetNode = slides[currentIndex + 1];
                break;
            case NAV_PREV_SLIDE:
                targetNode = slides[currentIndex - 1];
                break;
            default:
                {
                    var targetNodeId = getNodeId(action, state$.value.claims, state$.value.cbook.id, state$.value.currentSlide, state$.value.nodes, slides);
                    targetNode = slides.find(function(n) {
                        return n.id === targetNodeId;
                    });
                    break;
                }
        }
        if (targetNode && state$.value.api) {
            if (isSlideAvailable(targetNode, state$.value)) {
                var _state$_value_cbook1, _state$_value_cbook2;
                // if the navigation target node can actually be navigated to
                var status = state$.value.api.getSlideStatus(targetNode.id) || "not attempted";
                // change slide status from "not attempted" to incomplete to account for
                // the target node being navigated to for the first time
                if (status === "not attempted") {
                    state$.value.api.setSlideStatus(targetNode.id, "incomplete");
                }
                // set the currentSlide's value in the scorm api to the target node's id
                state$.value.api.setCurrentSlide(targetNode.id);
                // update the hmtl document's title in case the cBook name does not match the current value
                if (state$.value.cbook && document.title !== state$.value.cbook.name) {
                    document.title = state$.value.cbook.name;
                }
                // do some tracking
                var ntime = +new Date();
                var time = (ntime - timestamp).toFixed(2);
                Tracker.trackEvent("chartChange", action.origin ? "".concat(action.origin, " >> ").concat(targetNode.id, "  .. stayed (").concat(time, " sec)") : " > ".concat(targetNode.id, " .. stayed (").concat(time, " sec)"));
                timestamp = ntime;
                // add "set the currentSlide's value in the redux store to the target node's id"
                // to the actions that will be executed
                var actions = [
                    setLastVisitedSlide({
                        id: state$.value.currentSlide
                    }),
                    setCurrentSlide({
                        id: targetNode.id,
                        origin: action.origin,
                        quickFavOrigin: action.quickFavOrigin || state$.value.quickFavOriginSlide
                    })
                ];
                // account for slide completion in free navigation mode
                if (((_state$_value_cbook1 = state$.value.cbook) === null || _state$_value_cbook1 === void 0 ? void 0 : _state$_value_cbook1.mode) === "free" && state$.value.completed.indexOf(targetNode.id) === -1 && !/(^Exam)/.test(targetNode.target_type)) {
                    // TO DO: this might be problematic since some slides handle the completion through their own logic
                    // e.g. also in free mode, a multiple choice has to be answered to count as completed
                    // also: does the user have to do it in story mode to count as completed in free navigation mode?
                    actions.push(completeSlide({
                        id: targetNode.id
                    }));
                }
                // account for slide completion in linear navigation mode
                if (((_state$_value_cbook2 = state$.value.cbook) === null || _state$_value_cbook2 === void 0 ? void 0 : _state$_value_cbook2.mode) === "linear" && !/(^Page|Template|Extension)/.test(targetNode.target_type) && state$.value.completed.indexOf(targetNode.id) === -1 && !state$.value.storyMode) {
                    // warn the user that they have to complete the slide in story mode
                    // if the navigation mode is linear and if it is not a text page, a template page or an extension
                    // TO DO: Maybe we have to rethink this rule
                    actions.push(sendNotification({
                        key: "storyModeSwitched",
                        message: "navigation.complete_in_storyMode",
                        label: "ui.attention",
                        notificationType: "warning"
                    }));
                }
                // reset exam on navigation if there is currently one in the redux store
                // since navigation outside an exam will take us away from the exam
                if (state$.value.exam) {
                    actions.push(resetExam());
                }
                // if the navigation target node is an exam, initialize it
                if (targetNode.target_type === "Exam") {
                    actions.push(initExam({
                        id: targetNode.id
                    }));
                    actions.push(fetchExamInteractions({
                        nodeId: targetNode.id,
                        targetId: targetNode.target_id
                    }));
                }
                // INFO: Move focus back to the beggining of the slide so users don't have to tab backwards
                var mainLandmark = document.querySelector("#main");
                mainLandmark === null || mainLandmark === void 0 ? void 0 : mainLandmark.focus();
                return actions;
            } else {
                // if the navigation target node cannot be navigated to
                // e.g. because of unmet conditions in linear navigation mode
                var _getNearestAvailable = _slicedToArray(getNearestAvailable(targetNode, state$.value), 2), nextSlide = _getNearestAvailable[0], unavailablecount = _getNearestAvailable[1];
                return [
                    sendNotification({
                        key: "content-not-allowed-".concat(targetNode.id),
                        label: "ui.no_permissions",
                        message: "navigation.not_allowed",
                        messageProps: {
                            startId: nextSlide === null || nextSlide === void 0 ? void 0 : nextSlide.id,
                            multiple: unavailablecount > 1,
                            slideName: nextSlide === null || nextSlide === void 0 ? void 0 : nextSlide.name
                        }
                    })
                ];
            }
        } else {
            // if target node does not exist (or api is not available, but this is unlikely)
            return [
                logError({
                    error: new Error("Could not navigate to Slide because it does not exist"),
                    key: "on_nav_does_not_exist"
                })
            ];
        }
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "on_nav"
        }));
    }));
}
function getNodeId(action, claims, cBookId, currentSlide, nodes, slides) {
    if (action.localId) {
        /**
     * check in which node to look for claims
     * either the root node, or the current node
     */ var nodeClaims = [];
        if (action.quickFavOrigin && claims[cBookId]) {
            nodeClaims = claims[cBookId] || [];
        } else if (currentSlide && claims[currentSlide]) {
            nodeClaims = claims[currentSlide] || [];
        }
        if (nodeClaims && nodeClaims.length) {
            var claim = nodeClaims.find(function(c) {
                return c.local_id === action.localId && c.type === "node_claim";
            });
            if (claim) {
                // check if the claim's node is a chart node
                if (slides.some(function(s) {
                    return s.id === claim.node_id;
                })) {
                    return claim.node_id;
                }
                // get first chart of a chapter if the claim's node is a chapter
                var chapterNode = nodes.find(function(n) {
                    return n.target_type === "Filter" && n.id === claim.node_id;
                });
                if (chapterNode && chapterNode.c && chapterNode.c.length) {
                    return chapterNode.c[0];
                }
            }
        }
        return undefined;
    } else {
        return action.id;
    }
}
